import React from 'react';
import styles from './styles/category-badge.scss';

const CategoryBadge = (props) => {
    const {
        label,
        color,
        isShowProduct = false,
        expand = false,
    } = props;
    return (
        <div className={`${styles.categoryBadge} ${isShowProduct ? styles.isShowProduct : ''}`}>
            <span
                className={`${styles.categoryBadge__title} ${expand ? styles.categoryBadge__title__expand : ''}`}
                title={label}
            >
                {label}
            </span>
            <span className={styles.categoryBadge__tail} />
        </div>
    );
};

export default CategoryBadge;



/** WEBPACK FOOTER **
 ** ./src/components/product/category-badge.js
 **/